module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markCorrect--dark-7c03f3d888c70aef2281d899549d9632.png";